module.exports = __webpack_public_path__ + "static/media/Avenir-BlackOblique.292dd00e.ttf";